module.exports = __webpack_public_path__ + "img/szyw.4d2b17af.svg";